module.exports = __webpack_public_path__ + "a8af777701ae36cd4d8a23f4277022ec.jpg";